export enum CookieKey {
  ACCESS_TOKEN = 'token_1',
  REFRESH_TOKEN = 'token_2',
  UUID = 'uuid',
}
